import React, { useRef } from 'react';
import styled from 'styled-components';
import { useToggleState } from '@react-stately/toggle';
import { useLabel } from '@react-aria/label';
import { useCheckbox } from '@react-aria/checkbox';

type CheckboxAriaProps = React.PropsWithChildren<{
  label?: string,
  children?: JSX.Element | JSX.Element[],
}>;

export const CheckboxAria = (props : CheckboxAriaProps) => {
  const state = useToggleState(props);
  const ref = useRef(null);
  const { inputProps } = useCheckbox(props, state, ref);
  const { labelProps, fieldProps } = useLabel(props);

  return (
    <CheckboxAriaContainer>
      <CheckboxAriaLabel { ...labelProps } >
        { props.label }
      </CheckboxAriaLabel>
      <CheckboxAriaInput { ...inputProps } { ...fieldProps } ref = { ref }/>
      { props.children }
    </CheckboxAriaContainer>
  );
};

export const CheckboxAriaContainer = styled.div``;
export const CheckboxAriaLabel = styled.label``;
export const CheckboxAriaInput = styled.input``;
